<template lang="pug">
v-content
  v-toolbar.page-header(app, flat, fixed, color='white', height='105')
    v-breadcrumbs.ml-0(divider='/')
      v-breadcrumbs-item(disabled='')
        h2.ma-0 Invention Opportunities
    v-spacer
    v-btn.page-header__action(to='/opportunities/opportunity/add', exact='', color='primary', v-if='CR.authorization.state.isOrgAdmin')
      | Add Opportunity

  v-container.pa-0(fluid, grid-list-lg)
    v-layout(row, nowrap)
      v-flex.pr-4
        v-layout(row, wrap)
          v-flex(v-for='opportunity in C.data.opportunities', :key='opportunity.id')
            v-card
              v-card-title.pb-0(primary-title)
                h2.headline
                  | {{ opportunity.title }}
              v-card-text
                v-layout(row, wrap)
                  v-flex
                    span.grey--text
                      | Expires {{ opportunity.closing_time | moment("MMM D, YYYY") }}
                      span(v-if='opportunity.status')
                        |  ({{ opportunity.status }})
                  v-spacer
                  v-flex.text-xs-right
                    span.grey--text
                      | {{ opportunity.organization.name }}
              v-card-text.wrap.pt-0
                | {{ opportunity.short_description }}
              v-card-actions.px-3.pb-4
                v-btn(@click='C.trigger.downloadFile(opportunity)', color='primary', v-if='opportunity.uploaded_filename')
                  | Download
                v-btn(:to='{name: "OpportunityEdit", params: { id: opportunity.id }}', v-if='CR.authorization.state.isGod || (CR.authorization.state.organization && CR.authorization.state.organization[`id-${opportunity.organization.id}`] && CR.authorization.state.organization[`id-${opportunity.organization.id}`].isAdmin)')
                  | Edit

      v-flex(style='position: relative; flex: 0 0 236px')
        .d-block(style='width: 220px; position: fixed')
          .body-1.mb-0
            | Sort by:
          v-select.input--box(v-if='C.filters.list.organizations.length > 1', v-model='C.filters.selected.organization_id', label='All Organizations', v-bind:items='C.filters.list.organizations', item-text='name', item-value='id', single-line, :clearable='true', :hide-details='true')
          v-select.input--box(v-model='C.filters.selected.status', v-bind:items='C.filters.list.statuses', label='All Statuses', item-text='label', item-value='value', single-line, :clearable='true', hide-details)
          v-layout(row, nowrap)
            v-flex(sm6)
              v-btn(block, @click='C.trigger.refreshBaseData({ filters: C.filters.selected })')
                | Go
            v-flex(sm6)
              v-btn(block, @click='C.trigger.refreshBaseData()', v-if='C.filters.selected.organization_id || C.filters.selected.status')
                | Reset
</template>

<script>
  import tools from '../../assets/tools.js'
  import globalSettings from '../../assets/global-settings.js'
  import axios from '../../../node_modules/axios/dist/axios.js'

  export default {
    data () {
      return {
        CR: {
          authorization: globalSettings.authorization,
          show: globalSettings.show
        },
        C: {
          data: {
            opportunities: []
          },
          filters: {
            selected: {
              organization_id: null,
              status: null
            },
            list: {
              organizations: [],
              statuses: [{
                label: 'Active',
                value: 'Active'
              }, {
                label: 'Inactive',
                value: 'Inactive'
              }]
            }
          },
          trigger: {
            downloadFile: (opportunityItem) => {
              console.log('Running C.trigger.downloadFile()')

              axios.get(`${process.env.BASE_API_URL}${process.env.BASE_API_VERSION}/invention_opportunities/download_uploaded_file`, {
                params: {
                  invention_opportunity_id: opportunityItem.id
                },
                responseType: 'blob'
              })
                   .then(response => {
                     const url = window.URL.createObjectURL(new Blob([response.data]))
                     const link = document.createElement('a')

                     link.href = url
                     link.setAttribute('download', opportunityItem.uploaded_filename)
                     document.body.appendChild(link)
                     link.click()
                   })
                   .catch(errorResponse => {
                     tools.alert({
                       type: 'error',
                       errorResponse: errorResponse
                     })
                   })
            },
            refreshBaseData: (options) => {
              var component = this

              options = options || {}

              var filters = options.filters || {}

              var submitItem = {
                page: 1,
                size: 50,
                sort_column: 'created_at',
                sort_order: 'desc'
              }

              submitItem.organization_id = filters.organization_id || null
              submitItem.status = filters.status || null

              axios.get(`${process.env.BASE_API_URL}${process.env.BASE_API_VERSION}/invention_opportunities/list`, {
                params: submitItem
              })
                   .then(response => {
                     var opportunitiesList = (response && response.data && response.data.data && response.data.data.invention_opportunities) || []

                     component.C.data.opportunities = opportunitiesList

                     component.C.filters.selected.organization_id = submitItem.organization_id
                     component.C.filters.selected.status = submitItem.status
                   })
                   .catch(errorResponse => {
                     tools.alert({
                       type: 'error',
                       errorResponse: errorResponse
                     })
                   })
            }
          }
        }
      }
    },
    created () {
      var component = this

      component.C.trigger.refreshBaseData()

      tools.loggedInData({
        success: function (loggedInItem) {
          if (loggedInItem.state.isGod || loggedInItem.state.isOrgAdmin) {
            tools.getOrganizationsList({
              success: function (organizationList) {
                component.C.filters.list.organizations = organizationList
              }
            })
          }
        },
        error: function (errorResponse) {
          tools.alert({
            type: 'error',
            errorResponse: errorResponse
          })
        }
      })
    }
  }
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Opportunities/Opportunities.vue